import { configure } from 'mobx';

export const initializeMobx = () => {
  configure({
    enforceActions: 'always',
    computedRequiresReaction: true,
    reactionRequiresObservable: true,
    observableRequiresReaction: true,
    useProxies: 'ifavailable',
  });
};
